<template>
    <workspace-layout>

        <template v-slot:breadcrumbs>
            <el-breadcrumbs v-if="!$root.isMobile" :canEdit="false" :showCrumb="false" :parents="[]" :current="{ title: workspace.company }" />
        </template>

        <template v-slot:page>
            <div class="row position-relative h-100">
                <page-error-layout :type="`i-${status}`">
                    <template v-slot:title>
                        {{$t(`${$options.name}.${status}.title`)}}
                    </template>
                    <template v-slot:description>
                        {{$t(`${$options.name}.${status}.description`)}}
                    </template>
                </page-error-layout>
            </div>
        </template>
    </workspace-layout>
</template>

<script>
import { ElBreadcrumbs } from "@/components/elements/_index";
import PageErrorLayout from "@/layouts/page-error";

export default {
    name: "errors.general.auth",

    components: {
        ElBreadcrumbs,
        PageErrorLayout,
        WorkspaceLayout: () => import(/* webpackChunkName: "layouts" */ "@/layouts/workspace")
    },

    props: {
        status: {
            type: String,
            required: true
        }
    },

    computed: {
        workspace() {
            return this.$store.getters['workspace/current']
        }
    },
};
</script>
